// 3分時限閲覧のカウントダウン / ブロック中表示用に ~1秒ごとに更新される現在時刻(ミリ秒)。
// watch は使わず computed で派生させるため、時間経過で再評価される reactive な now を提供する。
// (Documents/Plan/Trial3minutes/Plan20260706.md / ADR-012)

let started = false;

export const useNowTicker = (): Ref<number> => {
  const now = useState<number>("nowTicker", () => Date.now());
  // クライアントでのみ 1本の interval を張る (SSR では静的値のまま)
  if (import.meta.client && !started) {
    started = true;
    setInterval(() => {
      now.value = Date.now();
    }, 1000);
  }
  return now;
};
